import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Offline from './offline';
import { fetchNetworkStatus } from '../../api/NetworkDetector.Api';
const inBrowser = typeof navigator !== 'undefined';

// these browsers don't fully support navigator.onLine, so we need to use a polling backup
const unsupportedUserAgentsPattern = /Windows.*Chrome|Windows.*Firefox|Linux.*Chrome/;
class NetworkDetector extends PureComponent {
  constructor() {
    super();
    /**
     * @description Function to set online status
     */
    this.goOnline = () => {
      if (!this.state.online) {
        this.callOnChangeHandler(true);
        this.setState({
          online: true
        });
      }
    };
    /**
     * @description Function to set the offline status
     */
    this.goOffline = () => {
      if (this.state.online) {
        this.callOnChangeHandler(false);
        this.setState({
          online: false
        });
      }
    };
    /**
     * @description Function to invoke onChange function if passed any
     * @param {Boolean} online - status of the network connection
     */
    this.callOnChangeHandler = online => {
      if (this.props.onChange) {
        this.props.onChange(online);
      }
    };
    /**
     * @description Function to start polling event
     */
    this.startPolling = () => {
      const {
        polling
      } = this.props;
      const {
        interval,
        url,
        timeout
      } = polling;
      this.pollingId = setInterval(() => {
        fetchNetworkStatus(url, timeout).then(online => {
          online ? this.goOnline() : this.goOffline();
        }).catch(error => {
          const {
            response
          } = error;
          if (response && response.status !== 404) {
            this.goOffline();
          } else {
            this.stopPolling();
          }
        });
      }, interval);
    };
    /**
     * @description Function to stop polling event
     */
    this.stopPolling = () => {
      clearInterval(this.pollingId);
    };
    this.state = {
      online: inBrowser && typeof navigator.onLine === 'boolean' ? navigator.onLine : true
    };
  }
  componentDidMount() {
    window.addEventListener('online', this.goOnline);
    window.addEventListener('offline', this.goOffline);
    const {
      enabled
    } = this.props;
    if (enabled) {
      this.startPolling();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('online', this.goOnline);
    window.removeEventListener('offline', this.goOffline);
    if (this.pollingId) {
      this.stopPolling();
    }
  }
  render() {
    const {
      online
    } = this.state;
    return /*#__PURE__*/React.createElement(Fragment, null, !online ? /*#__PURE__*/React.createElement(Offline, null) : null);
  }
}

// PropTypes declaration
NetworkDetector.propTypes = {
  enabled: PropTypes.bool,
  onChange: PropTypes.func,
  polling: PropTypes.shape({
    interval: PropTypes.number,
    timeout: PropTypes.number,
    url: PropTypes.string
  })
};

// Default prop values
NetworkDetector.defaultProps = {
  enabled: inBrowser && unsupportedUserAgentsPattern.test(navigator.userAgent),
  polling: {
    interval: 10000,
    timeout: 10000,
    url: 'https://gwarflbvd2.execute-api.us-west-1.amazonaws.com/dev/whatismyip'
  }
};
export default NetworkDetector;